// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__21wPY","footer":"Form_footer__vCRas"};